export const SWW = "Something went wrong!"